<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-12-27 11:27:54
-->
<template>
  <ol class="component--cat-editor__legend">
    <li>双击【记忆库】、【机器翻译】、【术语库】行可自动添加匹配译文。</li>
    <li>
      <p>图标说明：</p>
      <ol>
        <li>
          <div class="sentence-status-icon__wrapper inline-block">
            <SentenceStatusIcon
              is-cell-empty
              :status="TU_STATUS.translating"
            ></SentenceStatusIcon>
          </div>
          未翻译
        </li>
        <li v-for="s in detailStages" :key="s">
          <div class="sentence-status-icon__wrapper inline-block">
            <SentenceStatusIcon :status="s"></SentenceStatusIcon>
          </div>
          {{ getStageDetailText(s) }}
        </li>
        <li class="take-whole-line"></li>
        <li v-for="ss in sentenceSourcesPart1" :key="ss.id">
          <sentenceSourceSymbol v-bind="ss"></sentenceSourceSymbol>
          {{ ss.text }}
        </li>
        <li class="w-100">
          <div class="source_tb">TB</div>
          句段中的术语
        </li>
        <li v-for="ss in sentenceSourcesPart2" :key="ss.id">
          <sentenceSourceSymbol v-bind="ss"></sentenceSourceSymbol>
          {{ ss.text }}
        </li>
        <li style="line-height: 22px">
          <div class="qa__types">
            <span class="float-left">质量保证（QA）：</span>
            <div class="float-left">
              <span v-for="t in qaLevels" :key="t" class="mr-6">
                <fa-icon
                  :class="`qa-issue__type-${t}`"
                  icon="exclamation-circle"
                ></fa-icon>
                &nbsp;{{ getQALevelText(t) }}&nbsp;&nbsp;
                <div :class="['qa-icon-wrapper', `qa-issue__type-${t}`]">
                  <fa-icon
                    :class="`qa-issue__type-${t}`"
                    icon="exclamation-circle"
                  ></fa-icon>
                </div>
                &nbsp;{{ `${getQALevelText(t)}(当前QA结果)` }}
                <br />
              </span>
            </div>
          </div>
        </li>
      </ol>
    </li>
  </ol>
</template>

<script>
import SentenceStatusIcon from "./SentenceStatusIcon.vue";
import sentenceSourceSymbol from "./sentenceSourceSymbol.vue";
import { TU_STATUS, getStageDetailText, TARGET_SOURCE } from "./data";
import { QA_LEVEL, getQALevelText } from "../../components/data";
export default {
  components: { SentenceStatusIcon, sentenceSourceSymbol },
  data() {
    return {
      TU_STATUS,
      detailStages: Object.values(TU_STATUS),
      sentenceSourcesPart1: [
        {
          id: 10,
          source: TARGET_SOURCE.autofillByTM,
          score: 100,
          text: "100%匹配：记忆库中句段和原文句段100%匹配",
        },
        {
          id: 11,
          source: TARGET_SOURCE.autofillByTM,
          score: 101,
          text: "上下文匹配：记忆库中句段和原文句段100%匹配，且两个句段的上下文相同",
        },
        {
          id: 12,
          source: TARGET_SOURCE.autofillByTM,
          score: 75,
          text: "模糊匹配：记忆库中句段和原文句段匹配度介于0%~100%",
        },
        {
          id: 13,
          source: TARGET_SOURCE.autofillByTM,
          score: 75,
          isChanged: true,
          text: "记忆库自动匹配的译文被人工编辑",
        },
      ],
      sentenceSourcesPart2: [
        { id: 14, source: TARGET_SOURCE.autofillByMT, text: "机器翻译结果" },
        {
          id: 15,
          source: TARGET_SOURCE.autofillByMT,
          isChanged: true,
          text: "机器翻译结果被人工编辑",
        },
      ],
      qaLevels: Object.values(QA_LEVEL),
    };
  },
  methods: {
    getQALevelText,
    getStageDetailText,
  },
};
</script>

<style lang="scss">
.component--cat-editor__legend {
  list-style-type: decimal;
  width: 560px;
  font-size: 12px;

  ol {
    list-style-type: lower-latin;
    padding: 0 24px;

    li {
      float: left;
      min-width: 33%;
      margin-bottom: 12px;

      &.take-whole-line {
        display: block;
        clear: both;
        width: 100%;
        margin: 0;
      }

      .sentence-status-icon__wrapper {
        width: 20px;
      }
    }

    .component__cat-editor--sentence-source-symbol {
      width: 48px;
      display: inline-flex;
    }
  }

  .source_tb {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 20px;
    background-color: #9a8bdc;
    color: white;
  }
}
</style>